import { defineComponent as _defineComponent } from 'vue'
import { Link } from "@inertiajs/vue2";
import IconArrowRightTop from "@/components/icons/help/IconArrowRightTop.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpScrollingArticle',
  props: {
    article: null
  },
  setup(__props: any) {

const props = __props as {
  article: {
    id: number;
    title: string;
    imageUrl: string;
    description: string;
    category: string;
  };
};



return { __sfc: true,props, Link, IconArrowRightTop }
}

})